import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import qs from 'query-string';
import Theme from '../../Theme';
import Breadcrumb from '../../Components/Breadcrumb';

const content = [
  {
    target: '_blank',
    href: '/download/1-1會員團體保險辦法.pdf',
    name: '1-1. 會員團體保險辦法',
  },
  {
    target: '_blank',
    href: '/download/1-2會員團體保險理賠申請書／中國人壽申請書1080101.pdf',
    name: '1-2. 會員團體保險理賠申請書／中國人壽申請書1080101',
  },
  {
    target: '_blank',
    href:
      '/download/1-3會員團體保險理賠申請表／中國人壽／1080101(填寫範例).pdf',
    name: '1-3. 會員團體保險理賠申請表範例／中國人壽／1080101',
  },
  {
    target: '_blank',
    href: '/download/1-4 85歲以上會員死亡給付申請辦法／申請書／繼承系統表.pdf',
    name: '1-4. 85歲以上會員死亡給付申請辦法／申請書／繼承系統表',
  },
  {
    target: '_blank',
    href: '/download/2入會滿20年退會回饋金／退休申請.pdf',
    name: '2. 入會滿20年退會回饋金／退休申請',
  },
  {
    target: '_blank',
    href: '/download/3災害給付申請辦法暨申請表.pdf',
    name: '3. 災害給付申請辦法暨申請表',
  },
  {
    target: '_blank',
    href: '/download/4會員「死亡」子女教育協助金申請辦法暨申請表.pdf',
    name: '4. 會員「死亡」子女教育協助金申請辦法暨申請表',
  },
  {
    target: '_blank',
    href: '/download/5會員「重殘」子女教育協助金申請辦法暨申請表.pdf',
    name: '5. 會員「重殘」子女教育協助金申請辦法暨申請表',
  },
  {
    target: '_blank',
    href:
      '/download/6會員子女成績優異獎勵〔獎狀〕申請辦法暨申請表.pdf?v=210428',
    name: '6. 會員子女成績優異獎勵〔獎狀〕申請辦法暨申請表',
  },
  {
    target: '_blank',
    href: '/download/7會員婚喪喜慶申請辦法.pdf?v=20220311',
    name: '7. 會員婚喪喜慶申請辦法',
  },
  {
    target: '_blank',
    href: '/download/8資深會員會費優惠申請辦法暨申請表.pdf',
    name: '8. 資深會員會費優惠申請辦法暨申請表',
  },
  {
    target: '',
    href: '/download/9台北市牙醫師公會醫事委員會會員醫療糾紛處理流程.docx',
    name: '9. 台北市牙醫師公會醫事委員會會員醫療糾紛處理流程',
  },
  {
    target: '',
    href: '/download/10醫師醫療超額責任保險.docx',
    name: '10. 醫師醫療超額責任保險',
  },
];

function MemberBenefit(props) {
  return (
    <Wrapper>
      <div className="tda-header">
        <h2>會員福利</h2>
        <Breadcrumb third="會員福利" />
      </div>

      <div>連結未完成</div>

      <ul className="tda-list">
        {content.map((item, idx) => (
          <li key={idx}>
            <a href={item.href} target={item.target}>
              {item.name}
            </a>
          </li>
        ))}
      </ul>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  li {
    padding: 10px;

    a {
      color: #000;
    }

    &:hover {
      a {
        color: #fff;
      }
    }
  }
`;

export default withPageEntry(MemberBenefit);
